import { getWeekdayLabels } from '@components/toggle-group';
import { getScopedTranslate } from '@locale/translate';

const phraseLocale = {
  en: {
    onAnyDay: 'on any day',
    onWeekdays: 'on weekdays',
    onWeekends: 'on weekends',
    onSpecificDays: 'on {days}',
  },
};

export const getAllowedDaysPhrase = (allowedWeekdays: number[] | null | undefined): string => {
  if (!allowedWeekdays || allowedWeekdays.length === 0) return '';
  const sorted = [...allowedWeekdays].sort();
  const sortedKey = sorted.join(',');
  const { t } = getScopedTranslate(phraseLocale);

  if (sorted.length === 7) return t('onAnyDay');
  if (sortedKey === '1,2,3,4,5') return t('onWeekdays');
  if (sortedKey === '6,7') return t('onWeekends');
  const labels = getWeekdayLabels();
  return t('onSpecificDays', { days: sorted.map((day) => labels[day]).join(', ') });
};
